import { render, staticRenderFns } from "./ServicesReservationFloatBtns.vue?vue&type=template&id=14fdde15&"
import script from "./ServicesReservationFloatBtns.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports